<template>
  <AttrImage
    class="mt-2.5"
    label="背景填充"
    :base64="images['photoAlbumBg']"
    :disabled="attrDisabled == 'not-image'"
    @change="(imagePath: string) => onImageUpdate(imagePath,'photoAlbumBg')"
    @delete="() => onImageDelete('photoAlbumBg')"
  />
  <AttrImage
    v-if="watchfaceStroe.watchfaceType == 'portrait'"
    class="mt-2.5"
    label="人像抠图"
    :base64="images['photoAlbumFg']"
    :disabled="attrDisabled == 'not-image'"
    @change="(imagePath: string) => onImageUpdate(imagePath,'photoAlbumFg')"
    @delete="() => onImageDelete('photoAlbumFg')"
  />
</template>
<script lang="ts" setup>
import { computed, PropType } from 'vue';
import { useEditorStore } from '@/store/use-editor-store';
import { Shape } from '@/services/shape';
import { ResourceKey } from '@/services/shape/attributes';
import { useWatchfaceStore } from '@/store/use-watchface-store';

const watchfaceStroe = useWatchfaceStore();
const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const images = computed(() => {
  const photoAlbumBg = props.shape.getResources({
    resourceName: 'photoAlbumBg',
    colorGroup: editorStore.themeColor?.id ?? '',
    base64: true
  })?.[0];
  const photoAlbumFg = props.shape.getResources({
    resourceName: 'photoAlbumFg',
    colorGroup: editorStore.themeColor?.id ?? '',
    base64: true
  })?.[0];
  return { photoAlbumBg, photoAlbumFg };
});

const onImageUpdate = (imagePath: string, resourceName: ResourceKey) => {
  props.shape?.uploadResource(
    {
      resourceName,
      colorGroup: editorStore.themeColor?.id ?? '',
      realpath: imagePath
    },
    false
  );
};

const onImageDelete = (resourceName: ResourceKey) => {
  props.shape?.deleteResource({
    resourceName,
    colorGroup: editorStore.themeColor?.id ?? ''
  });
};
</script>
